import Head from 'next/head'
import React from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Flex } from 'components/Layout'
import { prepareGetStaticNavigationProps } from 'routes/utils/prepareGetStaticNavigationProps'
import { SPACE } from 'Theme'

const DESCRIPTION =
  'Subscribe to our newsletter and get 10% off your first order.'

export const Subscribe = () => (
  <>
    <Head>
      <title>The Expert Trade Program</title>
      <meta name="description" content={DESCRIPTION} />
      <meta name="twitter:description" content={DESCRIPTION} />
      <meta property="og:description" content={DESCRIPTION} />
    </Head>
    <Flex width="100%" justifyContent="center" py={SPACE.PX_32}>
      <div className="klaviyo-form-XqweWG" />
    </Flex>
  </>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

Subscribe.getLayout = (page) =>
  getPublicLayout(page, {
    isFullWidth: true,
  })
